















import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

@Component({
  name: 'catalog-product-list-price-filter',
  components: {
    VueSlider
  }
})

export default class extends Vue {
  @Prop() readonly dataSource: string;
  @Prop() readonly filter!: object;

  private showError: boolean = false;
  private filterOpen: boolean = !!!this.$mobileDetect.mobile();
  private minVal: number = 0;
  private maxVal: number = 0;
  private value: Array<number> = [0, 0];
  private sliderHeight: number = 0;

  private created(): void {
    this.showError = false;
    this.minVal = (this.filter['minimum_range'] || 0);
    this.maxVal = (this.filter['maximum_range'] || 0);
    this.value = [this.minValue, this.maxValue];
    this.sliderHeight = window.outerWidth > 940 ? 3 : 2;
  }

  @Watch('filter')
  private syncData(): void {
    this.minVal = this.filter['minimum_range'];
    this.maxVal = this.filter['maximum_range'];
    this.value = [this.minValue, this.maxValue];
  }

  private get minValue(): number {
    return this.filter['minimum_value'] > 0 && this.filter['minimum_value'] >= this.filter['minimum_range'] ? this.filter['minimum_value'] : this.filter['minimum_range'];
  }

  private get maxValue(): number {
    return this.filter['maximum_value'] > 0 && this.filter['maximum_value'] <= this.filter['maximum_range'] ? this.filter['maximum_value'] : this.filter['maximum_range'];
  }

  private toggleFilter(): void {
    this.filterOpen = !this.filterOpen;
  }

  private get validateInput(): boolean {
    return this.value[1] > this.value[0] && this.value[0] > 0;
  }

  private changePrice(): void {
    if (this.validateInput) {
      this.showError = false;
      let options = {
        minPrice: this.value[0],
        maxPrice: this.value[1]
      };
      this.$store.dispatch(`${this.dataSource}/updatePriceFilter`, options);
    } else {
      this.showError = true;
    }
  }
}
